export default "__VITE_ASSET__BsCZVKl4__"